import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import '../../services/GlobalVariables'

const API_URL = global.SET_API_URL + "users/"

const user = JSON.parse(localStorage.getItem('user'))

const initialState = {
    user: user ? user : null,
    allUsers: [],
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: ""
}

export const register = createAsyncThunk('auth/register', async (user, thunkAPI) => {
    try {

        const response = await axios.post(API_URL, user)

        return response.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const login = createAsyncThunk('auth/login', async (user, thunkAPI) => {
    try {
        const response = await axios.post(API_URL + 'loginUser', user)
        if (response.data.message) {
        } else {
            localStorage.setItem('user', JSON.stringify(response.data))
            return response.data
        }

    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getAllUsers = createAsyncThunk('auth/gau', async (cmpID, thunkAPI) => {
    try {
        const response = await axios.post(API_URL + 'getAllUsers', cmpID)
        return response.data

    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const getOldPassword = createAsyncThunk('auth/gop', async (userData, thunkAPI) => {
    try {
        const response = await axios.post(API_URL + 'getOldPassword', userData)
        return response.data

    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const changePassword = createAsyncThunk('auth/cp', async (userData, thunkAPI) => {
    try {
        const response = await axios.post(API_URL + 'changePassword', userData)
        return response.data

    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const logOut = createAsyncThunk('auth/logout', async (navigate) => {
    localStorage.removeItem('user')
    navigate('/Login')
})

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
            state.user = null
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(register.pending, (state) => {
                state.isLoading = true
            })
            .addCase(register.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.user = action.payload
            })
            .addCase(register.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.user = null
            })
            .addCase(login.pending, (state) => {
                state.isLoading = true
            })
            .addCase(login.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                if (action.payload === "User's License Is Not Expired!...") {
                    console.log('Done')
                }
                state.user = action.payload
            })
            .addCase(login.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.user = null
            })
            .addCase(getAllUsers.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllUsers.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.allUsers = action.payload
            })
            .addCase(getAllUsers.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.allUsers = null
            })
            .addCase(logOut.fulfilled, (state) => {
                state.user = null
            })
    }
})

export const { reset } = authSlice.actions

export default authSlice.reducer